import * as React from 'react';
import { withDataFetchNivo } from '../hoc/withDataFetchNivo';

const ResponsiveSunburst = React.lazy(() =>
  import('@nivo/sunburst').then(module => ({
    default: module.ResponsiveSunburst,
  }))
);

const SunBurstWidget: React.FC<any> = ({ data }) => {
  const {
    margin,
    identity,
    value,
    cornerRadius,
    borderWidth,
    borderColor,
    colors,
    childColor,
    animate,
    motionStiffness,
    motionDamping,
    isInteractive,
  } = data.view;

  return (
    <React.Suspense fallback="loading...">
      <ResponsiveSunburst
        data={data.data}
        margin={margin}
        identity={identity}
        value={value}
        cornerRadius={cornerRadius}
        borderWidth={borderWidth}
        borderColor={borderColor}
        colors={colors}
        childColor={childColor}
        animate={animate}
        motionStiffness={motionStiffness}
        motionDamping={motionDamping}
        isInteractive={isInteractive}
      />
    </React.Suspense>
  );
};

export default withDataFetchNivo(SunBurstWidget);
